export default "__VITE_ASSET__DmGFPw$l__"